import { Component, EventEmitter, input, Input, Output } from '@angular/core';

@Component({
  selector: 'app-perfil-profissional',
  imports: [],
  templateUrl: './perfil-profissional.component.html',
  styleUrl: './perfil-profissional.component.scss'
})
export class PerfilProfissionalComponent {

    @Output() onCloseModal = new EventEmitter<boolean>();
    
    perfilSelected = input<any>();

    
}
